import { FC, Fragment, useEffect } from "react";
import Typography from "@/components/Typography";
import { useInterviewsQuery } from "@/fetch/suppliers";
import { Skeleton } from "@/components/Loader";
import { EmptyJobsList } from "@/components/EmptyList";
import Divider from "@/components/Divider";
import { useTrackers } from "@/hooks";
import OfferedJob from "./OfferedJob";
import styles from "./OfferedTab.module.scss";

type Props = {
  //
};

const OfferedTab: FC<Props> = () => {
  const { data: interviewsData, isLoading } = useInterviewsQuery({
    status: "Offered",
  });

  const { track } = useTrackers();

  useEffect(() => {
    track("My Jobs Tab Viewed", {
      eventId: "my-jobs-tab-viewed",
    });
  }, []);

  const interviews = interviewsData?.offered || [];

  return (
    <div className={styles.container}>
      {isLoading ? (
        <Skeleton variant="rectangular" height={200} />
      ) : (
        <>
          {interviews.length > 0 ? (
            <>
              <Typography variant="h6" className={styles.title}>
                My Jobs
              </Typography>

              {/* <Typography color="text.secondary" variant="h6">
                  Offered jobs
                </Typography> */}
              {interviews.map((eachInterview, idx) => (
                <Fragment key={eachInterview.id}>
                  <OfferedJob matchInterview={eachInterview} />
                  {/* {idx !== interviews.length - 1 && (
                      <Divider className={styles.divider} />
                    )} */}
                </Fragment>
              ))}
            </>
          ) : (
            <EmptyJobsList variant="offered" />
          )}
        </>
      )}
    </div>
  );
};

export default OfferedTab;
